module.exports = __webpack_public_path__ + "static/img/interactivegames1.5ac052fc.png";